export default __webpack_public_path__ + "static/media/bbq.0026e592.jpg";